export const pages = {
	'boltHome': { id: 'boltHome', page: 'home', getter: () => import(/* webpackChunkName: 'boltHome' */ 'components/bolt/home/home') }
};
export const sections = [
	{ id: 'boltSynopsis', getter: () => import(/* webpackChunkName: "boltSynopsis" */ 'components/bolt/synopsis/synopsis'), component: 'synopsis' },
	{ id: 'resources', getter: () => import(/* webpackChunkName: "resources" */ 'components/bolt/resources/resources'), component: 'resources' }
];
export const sectionsWithParent = [

];
import SidePanelLoader from 'components/bolt/sidePanelLoader/sidePanelLoader';
export { SidePanelLoader };
import VideoOverlayLoader from 'components/bolt/videoOverlayLoader/videoOverlayLoader';
export { VideoOverlayLoader };
